module.exports = __webpack_public_path__ + "static/media/path02.2f8e394e.png";